
import SquareNoteIcon from '@/components/FileViewer/Icons/SquareNoteIcon.vue'
import TrashIcon from './Icons/TrashIcon.vue'
import PencilEditIcon from './Icons/PencilEditIcon.vue'
import XIcon from './Icons/XIcon.vue'

export default {
    name: 'HxNList',
    components: {
        SquareNoteIcon,
        TrashIcon,
        PencilEditIcon,
        XIcon
    },
    props: {
        filters: Object,
        highlight: Object,
        indexById: Object
    },
    inject: ['fvAPI_HighlightUpdate'],
    data () {
        return {
            editNote: false,
            currentNote: null,
            editedNote: null
        }
    },
    computed: {
        isInIndex () {
            return (this.highlight.parent_page_id in this.indexById) || (this.highlight.page_id in this.indexById)
        },
        title () {
            return this.indexById[this.highlight.parent_page_id ?? this.highlight.page_id].title
        }
    },
    watch: {
        highlight: {
            immediate: true,
            handler (newVal) {
                this.currentNote = newVal.note
                this.editedNote = newVal.note
            }
        }
    },
    methods: {
        deleteHighlight () {
            this.$emit('delete-highlight', this.highlight)
        },
        saveAndClose () {
            if (this.editedNote === this.currentNote) {
                this.editNote = false
                return
            }
            this.currentNote = this.editedNote
            const highlight = Object.assign({}, this.highlight)
            highlight.note = this.currentNote
            this.$emit('update-note', highlight)
            this.editNote = false
        },
        cancelEdit () {
            this.editedNote = this.currentNote
            this.editNote = false
        }
    }
}
